"use strict";

export function initInScope($scope) {

    $scope.find('.js-flyin__trigger').on('click', function (e) {
        const $trigger = $(this);
        const $target = $($trigger.data('flyin-target-id'));

        // open panel visually
        $target.addClass('is-open');

        // ARIA state management
        $trigger.attr('aria-expanded', 'true');
        $target.attr('aria-hidden', 'false');

        // Move focus into dialog for SR users
        // Focus the container (has tabindex="-1")
        if ($target.length) {
            $target.trigger('focus');
        }
    });

    $scope.find('.js-flyin__close').on('click', function (e) {
        // close all panels visually
        $('.js-flyin').removeClass('is-open').attr('aria-hidden', 'true');
        // reset all triggers expanded state
        $scope.find('.js-flyin__trigger').attr('aria-expanded', 'false');
        // Optionally return focus to the last trigger (not tracked here)
    });

}